import axios from "axios";
import { get, isEmpty } from "lodash";
import { InviteDetails } from "../views/create/create";
import { ForwardInviteDetails } from "../views/request-invitation/request-invitation";
export default class InviteService {
    environment: string;
    inviteUrl: string;

    constructor(environment: string) {
        this.environment = environment === "prod" ? "" : environment + ".";
        this.inviteUrl = `https://${this.environment}id.spsc.io/identity/`;
    }

    getInvite(inviteId: string) {
        return axios
            .get(`${this.inviteUrl}v3/users/invitations/unauthed/${inviteId}`)
            .then((response) => {
                let responseData = get(response, "data");
                if (!responseData) {
                    return Promise.reject(new Error("empty dataset"));
                }
                if (responseData.is_complete) {
                    return Promise.reject(new Error("complete"));
                }
                if (responseData.first_name && responseData.last_name && responseData.email) {
                    return {
                        firstName: responseData.first_name,
                        lastName: responseData.last_name,
                        email: responseData.email,
                    };
                } else {
                    return Promise.reject(new Error("missing data"));
                }
            });
    }

    finalizeInvite(inviteDetails: InviteDetails) {
        return axios.patch(`${this.inviteUrl}v3/users/invitations/verify/`, inviteDetails);
    }

    forwardInvite(inviteDetails: ForwardInviteDetails) {
        return axios.post(`${this.inviteUrl}v3/users/invitations/forward/`, inviteDetails);
    }
}
